import styles from "./tab.module.scss";
import cn from "classnames";

export default function UserTab({
  title,
  tabIndex,
  currrentTab,
  selectTab,
}: {
  title: string;
  tabIndex: number;
  currrentTab: number;
  selectTab: () => void;
}): JSX.Element {
  return (
    <div
      className={cn(styles.tab, {
        [styles.active]: tabIndex === currrentTab,
      })}
      onClick={selectTab}
    >
      <div className={styles.top_bar} />
      {title}
    </div>
  );
}
